// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  position: fixed;
  bottom: 14px;
  right: 14px;
  width: min(620px, calc(100vw - 28px));
  height: min(640px, calc(100vh - 90px));
  background: rgba(10, 14, 26, 0.92);
  border-radius: 18px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  z-index: 16000;
  animation: slideUp 0.3s ease;
  font-family: 'Space Grotesk', 'Sora', sans-serif;
  color: #eef1ff;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chat-header {
  background: linear-gradient(135deg, rgba(94, 228, 255, 0.22), rgba(255, 204, 102, 0.18));
  color: #f8f9ff;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.chat-header h2 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  background: rgba(255, 255, 255, 0.08);
  color: #f8f9ff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 4px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}

.chat-content {
  display: flex;
  flex: 1 1;
  overflow: hidden;
}

.conversations-list {
  width: 210px;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  background: rgba(10, 14, 26, 0.75);
}

.conversations-header {
  padding: 14px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.conversations-header h3 {
  margin: 0;
  font-size: 13px;
  color: #e5e9ff;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.refresh-btn {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  cursor: pointer;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: #e5e9ff;
}

.refresh-btn:hover {
  background: rgba(255, 255, 255, 0.14);
  transform: rotate(180deg);
}

.no-conversations {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  text-align: center;
  color: rgba(238, 241, 255, 0.7);
}

.no-conversations p {
  margin: 5px 0;
  font-size: 12px;
}

.no-conversations .hint {
  font-size: 11px;
  font-style: italic;
}

.conversation-item {
  padding: 12px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  background: rgba(255, 255, 255, 0.02);
  border-left: 3px solid transparent;
}

.conversation-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-left-color: #5ee4ff;
}

.conversation-item.active {
  background: linear-gradient(135deg, rgba(94, 228, 255, 0.25), rgba(255, 204, 102, 0.18));
  color: #f8f9ff;
  border-left-color: #f8f9ff;
}

.conversation-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.user-name {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.last-message {
  font-size: 11px;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.unread-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 99, 92, 0.85);
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
}

.messages-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: rgba(8, 12, 24, 0.9);
}

.messages-header {
  padding: 14px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.messages-header h3 {
  margin: 0;
  font-size: 14px;
  color: #eef1ff;
  font-weight: 600;
}

.typing-indicator {
  margin: 0;
  font-size: 11px;
  color: rgba(238, 241, 255, 0.7);
  font-style: italic;
  animation: blink 1.4s infinite;
}

@keyframes blink {
  0%, 20%, 50%, 80%, 100% {
    opacity: 1;
  }
  40% {
    opacity: 0.5;
  }
  60% {
    opacity: 0.7;
  }
}

.messages-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: radial-gradient(400px 200px at 20% 0%, rgba(94, 228, 255, 0.06), transparent 60%);
  position: relative;
}

.no-messages,
.no-selection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  color: rgba(238, 241, 255, 0.7);
}

.no-messages p,
.no-selection p {
  margin: 5px 0;
  font-size: 14px;
}

.no-messages .hint,
.no-selection .hint {
  font-size: 12px;
  font-style: italic;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgba(238, 241, 255, 0.7);
}

.messages-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12px;
  pointer-events: none;
}

.messages-loading-overlay__chip {
  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: rgba(238, 241, 255, 0.85);
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  backdrop-filter: blur(6px);
}

.message {
  display: flex;
  margin-bottom: 5px;
}

.message.sent {
  justify-content: flex-end;
}

.message.received {
  justify-content: flex-start;
}

.message-content {
  max-width: 74%;
  padding: 9px 12px;
  border-radius: 14px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
}

.message.sent .message-content {
  background: linear-gradient(135deg, rgba(94, 228, 255, 0.35), rgba(255, 204, 102, 0.25));
  color: #f8f9ff;
}

.message.received .message-content {
  background: rgba(255, 255, 255, 0.08);
  color: #eef1ff;
}

.timestamp {
  display: block;
  font-size: 11px;
  opacity: 0.7;
  color: rgba(238, 241, 255, 0.7);
  margin-top: 5px;
}

.message-input-area {
  padding: 15px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  gap: 10px;
  align-items: flex-end;
  flex-wrap: nowrap;
  background: rgba(10, 14, 26, 0.85);
}

.message-input {
  flex: 1 1;
  padding: 9px 11px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  resize: vertical;
  max-height: 86px;
  background: rgba(255, 255, 255, 0.04);
  color: #eef1ff;
}

.message-input:focus {
  outline: none;
  border-color: rgba(94, 228, 255, 0.6);
  box-shadow: 0 0 0 2px rgba(94, 228, 255, 0.2);
}

.send-btn {
  background: linear-gradient(135deg, rgba(94, 228, 255, 0.5), rgba(255, 204, 102, 0.4));
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  transition: all 0.2s ease;
  align-self: flex-end;
  white-space: nowrap;
  min-width: 70px;
}

.mobile-back-btn {
  display: none;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(255, 255, 255, 0.08);
  color: #eef1ff;
  border-radius: 8px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.send-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(94, 228, 255, 0.3);
}

.send-btn:active:not(:disabled) {
  transform: translateY(0);
}

.send-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: linear-gradient(135deg, #666 0%, #444 100%);
}

@media (max-width: 768px) {
  .chat-container {
    left: 8px;
    right: 8px;
    bottom: 8px;
    width: auto;
    height: min(88vh, 700px);
    border-radius: 14px;
  }

  .conversations-list {
    width: 100%;
    max-height: 36%;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .chat-content {
    flex-direction: column;
  }

  .chat-header {
    padding: 14px 16px;
  }

  .messages-header {
    padding: 10px 14px;
  }

  .message-input-area {
    padding: 10px 12px;
  }

  .message-content {
    max-width: 88%;
  }
}

@media (max-width: 560px) {
  .chat-content.has-selection .conversations-list {
    display: none;
  }

  .chat-content:not(.has-selection) .messages-area {
    display: none;
  }

  .mobile-back-btn {
    display: inline-flex;
  }

  .messages-list {
    padding: 12px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Chat.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;EAC3C,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,4BAA4B;EAC5B,gDAAgD;EAChD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wFAAwF;EACxF,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,qCAAqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,wFAAwF;EACxF,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6FAA6F;EAC7F,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;EAEE,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,wFAAwF;EACxF,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,sFAAsF;EACtF,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,kDAAkD;EACpD;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap');\n\n.chat-container {\n  position: fixed;\n  bottom: 14px;\n  right: 14px;\n  width: min(620px, calc(100vw - 28px));\n  height: min(640px, calc(100vh - 90px));\n  background: rgba(10, 14, 26, 0.92);\n  border-radius: 18px;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  z-index: 16000;\n  animation: slideUp 0.3s ease;\n  font-family: 'Space Grotesk', 'Sora', sans-serif;\n  color: #eef1ff;\n  overflow: hidden;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.chat-header {\n  background: linear-gradient(135deg, rgba(94, 228, 255, 0.22), rgba(255, 204, 102, 0.18));\n  color: #f8f9ff;\n  padding: 18px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.chat-header h2 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.close-btn {\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8f9ff;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  padding: 4px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 18px;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.chat-content {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.conversations-list {\n  width: 210px;\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  background: rgba(10, 14, 26, 0.75);\n}\n\n.conversations-header {\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.conversations-header h3 {\n  margin: 0;\n  font-size: 13px;\n  color: #e5e9ff;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.refresh-btn {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  cursor: pointer;\n  font-size: 14px;\n  padding: 4px 8px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  color: #e5e9ff;\n}\n\n.refresh-btn:hover {\n  background: rgba(255, 255, 255, 0.14);\n  transform: rotate(180deg);\n}\n\n.no-conversations {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  text-align: center;\n  color: rgba(238, 241, 255, 0.7);\n}\n\n.no-conversations p {\n  margin: 5px 0;\n  font-size: 12px;\n}\n\n.no-conversations .hint {\n  font-size: 11px;\n  font-style: italic;\n}\n\n.conversation-item {\n  padding: 12px 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  background: rgba(255, 255, 255, 0.02);\n  border-left: 3px solid transparent;\n}\n\n.conversation-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-left-color: #5ee4ff;\n}\n\n.conversation-item.active {\n  background: linear-gradient(135deg, rgba(94, 228, 255, 0.25), rgba(255, 204, 102, 0.18));\n  color: #f8f9ff;\n  border-left-color: #f8f9ff;\n}\n\n.conversation-info {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.user-name {\n  font-weight: 600;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.last-message {\n  font-size: 11px;\n  opacity: 0.7;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.unread-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(255, 99, 92, 0.85);\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.messages-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: rgba(8, 12, 24, 0.9);\n}\n\n.messages-header {\n  padding: 14px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.header-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.messages-header h3 {\n  margin: 0;\n  font-size: 14px;\n  color: #eef1ff;\n  font-weight: 600;\n}\n\n.typing-indicator {\n  margin: 0;\n  font-size: 11px;\n  color: rgba(238, 241, 255, 0.7);\n  font-style: italic;\n  animation: blink 1.4s infinite;\n}\n\n@keyframes blink {\n  0%, 20%, 50%, 80%, 100% {\n    opacity: 1;\n  }\n  40% {\n    opacity: 0.5;\n  }\n  60% {\n    opacity: 0.7;\n  }\n}\n\n.messages-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: radial-gradient(400px 200px at 20% 0%, rgba(94, 228, 255, 0.06), transparent 60%);\n  position: relative;\n}\n\n.no-messages,\n.no-selection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  color: rgba(238, 241, 255, 0.7);\n}\n\n.no-messages p,\n.no-selection p {\n  margin: 5px 0;\n  font-size: 14px;\n}\n\n.no-messages .hint,\n.no-selection .hint {\n  font-size: 12px;\n  font-style: italic;\n}\n\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: rgba(238, 241, 255, 0.7);\n}\n\n.messages-loading-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding-top: 12px;\n  pointer-events: none;\n}\n\n.messages-loading-overlay__chip {\n  background: rgba(0, 0, 0, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: rgba(238, 241, 255, 0.85);\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  backdrop-filter: blur(6px);\n}\n\n.message {\n  display: flex;\n  margin-bottom: 5px;\n}\n\n.message.sent {\n  justify-content: flex-end;\n}\n\n.message.received {\n  justify-content: flex-start;\n}\n\n.message-content {\n  max-width: 74%;\n  padding: 9px 12px;\n  border-radius: 14px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);\n}\n\n.message.sent .message-content {\n  background: linear-gradient(135deg, rgba(94, 228, 255, 0.35), rgba(255, 204, 102, 0.25));\n  color: #f8f9ff;\n}\n\n.message.received .message-content {\n  background: rgba(255, 255, 255, 0.08);\n  color: #eef1ff;\n}\n\n.timestamp {\n  display: block;\n  font-size: 11px;\n  opacity: 0.7;\n  color: rgba(238, 241, 255, 0.7);\n  margin-top: 5px;\n}\n\n.message-input-area {\n  padding: 15px 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n  flex-wrap: nowrap;\n  background: rgba(10, 14, 26, 0.85);\n}\n\n.message-input {\n  flex: 1;\n  padding: 9px 11px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  font-family: inherit;\n  font-size: 13px;\n  resize: vertical;\n  max-height: 86px;\n  background: rgba(255, 255, 255, 0.04);\n  color: #eef1ff;\n}\n\n.message-input:focus {\n  outline: none;\n  border-color: rgba(94, 228, 255, 0.6);\n  box-shadow: 0 0 0 2px rgba(94, 228, 255, 0.2);\n}\n\n.send-btn {\n  background: linear-gradient(135deg, rgba(94, 228, 255, 0.5), rgba(255, 204, 102, 0.4));\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 13px;\n  transition: all 0.2s ease;\n  align-self: flex-end;\n  white-space: nowrap;\n  min-width: 70px;\n}\n\n.mobile-back-btn {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(255, 255, 255, 0.08);\n  color: #eef1ff;\n  border-radius: 8px;\n  padding: 5px 9px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.send-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 14px rgba(94, 228, 255, 0.3);\n}\n\n.send-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.send-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: linear-gradient(135deg, #666 0%, #444 100%);\n}\n\n@media (max-width: 768px) {\n  .chat-container {\n    left: 8px;\n    right: 8px;\n    bottom: 8px;\n    width: auto;\n    height: min(88vh, 700px);\n    border-radius: 14px;\n  }\n\n  .conversations-list {\n    width: 100%;\n    max-height: 36%;\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  }\n\n  .chat-content {\n    flex-direction: column;\n  }\n\n  .chat-header {\n    padding: 14px 16px;\n  }\n\n  .messages-header {\n    padding: 10px 14px;\n  }\n\n  .message-input-area {\n    padding: 10px 12px;\n  }\n\n  .message-content {\n    max-width: 88%;\n  }\n}\n\n@media (max-width: 560px) {\n  .chat-content.has-selection .conversations-list {\n    display: none;\n  }\n\n  .chat-content:not(.has-selection) .messages-area {\n    display: none;\n  }\n\n  .mobile-back-btn {\n    display: inline-flex;\n  }\n\n  .messages-list {\n    padding: 12px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
